const initSeeMoreContent = () => {
  const seeMoreButtons = document.querySelectorAll('.see-more-content');
  if(seeMoreButtons){
    seeMoreButtons.forEach(button => {
      const target = document.getElementById(button.dataset.target);
      if(target){
        const isCharacterMode = button.dataset.mode === 'chars' || !!target.dataset.maxChars;
        if(isCharacterMode){
          const moreTextNode = target.querySelector('.subtitle-more');
          const ellipsisNode = target.querySelector('.subtitle-ellipsis');
          if(moreTextNode){
            button.textContent = button.dataset.seeMore;

            button.addEventListener('click', () => {
              const isExpanded = button.classList.contains('toggled');
              if(isExpanded){
                moreTextNode.classList.add('hidden');
                if(ellipsisNode){
                  ellipsisNode.classList.remove('hidden');
                }
                button.textContent = button.dataset.seeMore;
              }
              else {
                moreTextNode.classList.remove('hidden');
                if(ellipsisNode){
                  ellipsisNode.classList.add('hidden');
                }
                button.textContent = button.dataset.seeLess;
              }

              button.classList.toggle('toggled');
            });
            return;
          }

          const maxChars = Number(button.dataset.maxChars || target.dataset.maxChars || 0);
          const fullText = target.textContent.trim();

          if(!maxChars || fullText.length <= maxChars){
            button.classList.add('hidden');
            target.textContent = fullText;
            return;
          }

          const getTruncatedText = () => {
            const truncated = fullText.slice(0, maxChars);
            const lastSpace = truncated.lastIndexOf(' ');
            if(lastSpace <= 0){
              return truncated;
            }

            return truncated.slice(0, lastSpace);
          };

          const truncatedText = getTruncatedText();
          const textNode = document.createElement('span');
          const separatorNode = document.createElement('span');

          separatorNode.textContent = ' ';
          button.classList.remove('mt-4');
          button.classList.add('inline');
          button.textContent = button.dataset.seeMore;

          target.textContent = '';
          target.appendChild(textNode);
          target.appendChild(separatorNode);
          target.appendChild(button);

          const renderCollapsed = () => {
            textNode.textContent = truncatedText + '...';
            button.textContent = button.dataset.seeMore;
          };

          const renderExpanded = () => {
            textNode.textContent = fullText;
            button.textContent = button.dataset.seeLess;
          };

          renderCollapsed();
          button.addEventListener('click', () => {
            if(button.classList.contains('toggled')){
              renderCollapsed();
            }
            else {
              renderExpanded();
            }

            button.classList.toggle('toggled');
          });
          return;
        }

        const offsetHeight = target.offsetHeight;

        button.addEventListener('click', () => {
          if(button.classList.contains('toggled')){
            target.style.maxHeight = target.dataset.maxHeight + 'px';
            button.textContent = button.dataset.seeMore;
          }
          else {
            target.style.maxHeight = Number(offsetHeight + 30) + 'px';
            button.textContent = button.dataset.seeLess;
          }

          button.classList.toggle('toggled');
        });

        target.style.maxHeight = target.dataset.maxHeight + 'px';

        if(target.scrollHeight <= target.dataset.maxHeight){
          button.classList.add('hidden');
        }
      }
    });
  }
}

export { initSeeMoreContent }
